export default function Footer() {
  return (
    <footer className="relative bg-[#080C15] border-t border-white/10 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row items-start justify-between gap-8 mb-10">
          {/* Brand */}
          <div className="max-w-xs">
            <img
              src="https://public.readdy.ai/ai/img_res/1b690fcb-e208-48ed-96d2-9d63ebbac54c.png"
              alt="NegoIA Perú"
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-white/40 text-sm leading-relaxed">
              El ecosistema de Inteligencia Artificial diseñado exclusivamente para dueños de negocios peruanos que quieren vender más.
            </p>

          </div>

          {/* Links */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h4 className="text-white font-bold text-sm mb-4 uppercase tracking-widest">Producto</h4>
              <ul className="space-y-2">
                {["Características", "Precios", "Testimonios", "FAQ"].map((item) => (
                  <li key={item}>
                    <a href="#" className="text-white/40 hover:text-white/80 text-sm transition-colors duration-200 cursor-pointer">
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-white font-bold text-sm mb-4 uppercase tracking-widest">Legal</h4>
              <ul className="space-y-2">
                {["Términos de Uso", "Política de Privacidad", "Garantía", "Contacto"].map((item) => (
                  <li key={item}>
                    <a href="#" className="text-white/40 hover:text-white/80 text-sm transition-colors duration-200 cursor-pointer">
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-white font-bold text-sm mb-4 uppercase tracking-widest">Contacto</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-white/40 text-sm">
                  <i className="ri-whatsapp-line text-emerald-400"></i>
                  WhatsApp Soporte
                </li>
                <li className="flex items-center gap-2 text-white/40 text-sm">
                  <i className="ri-mail-line text-[#a78bfa]"></i>
                  hola@negoia.pe
                </li>
                <li className="flex items-center gap-2 text-white/40 text-sm">
                  <i className="ri-map-pin-line text-orange-400"></i>
                  Lima, Perú
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs text-center sm:text-left">
            &copy; 2025 NegoIA Perú. Todos los derechos reservados.
          </p>

        </div>
      </div>
    </footer>
  );
}
